/**
 * EqualWeb launcher placement + openMenu bind (hideBtn mode).
 * Desktop → Discover dropdown
 * Mobile  → drawer slot (after primary shop links)
 * Fallback → header icons rail if Discover slot missing
 */
(function () {
  var OPEN_COOLDOWN_MS = 600;
  var MOBILE_MQ = '(max-width: 749px)';
  var lastOpenAt = 0;
  var bound = false;

  function canOpen() {
    return !!(
      window.interdeal
      && window.interdeal.a11y
      && typeof window.interdeal.a11y.openMenu === 'function'
    );
  }

  function openMenu(event) {
    if (!canOpen()) return false;
    var now = Date.now();
    if (now - lastOpenAt < OPEN_COOLDOWN_MS) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      return true;
    }
    try {
      window.interdeal.a11y.openMenu();
      lastOpenAt = now;
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      return true;
    } catch (err) {
      return false;
    }
  }

  function onTouchEnd(event) {
    if (event.touches && event.touches.length > 0) return;
    openMenu(event);
  }

  function bind() {
    var btn = document.getElementById('INDmenu-btn');
    if (!btn || bound) return !!btn;
    btn.addEventListener('click', openMenu, true);
    btn.addEventListener('touchend', onTouchEnd, { capture: true, passive: false });
    btn.addEventListener('pointerup', function (event) {
      if (event.pointerType === 'touch' || event.pointerType === 'pen') {
        openMenu(event);
      }
    }, true);
    bound = true;
    btn.dataset.im8EqualwebBound = '1';
    return true;
  }

  function placeButton() {
    var btn = document.getElementById('INDmenu-btn');
    var drawer = document.querySelector('[data-equalweb-slot="drawer"]');
    var discover = document.querySelector('[data-equalweb-slot="discover"]');
    var icons = document.querySelector('[data-equalweb-slot="icons"]');
    if (!btn) return;

    var mobile = window.matchMedia(MOBILE_MQ).matches;
    var target = mobile ? drawer : (discover || icons);
    if (!target) return;

    if (btn.parentElement !== target) {
      target.appendChild(btn);
    }
    // Clear leftover whitespace text nodes so :empty / layout collapse works
    [drawer, discover, icons].forEach(function (slot) {
      if (!slot || slot === target) return;
      Array.prototype.slice.call(slot.childNodes).forEach(function (node) {
        if (node.nodeType === 3) slot.removeChild(node);
      });
    });
    // Match nav link type styles in Discover + mobile drawer
    var inDiscover = !mobile && target === discover;
    var inDrawer = mobile && target === drawer;
    btn.classList.toggle('mega-menu__link', inDiscover || inDrawer);
    btn.classList.toggle('mega-menu__link--level-2', inDiscover || inDrawer);
    var label = btn.querySelector('.equalweb-a11y-btn__label');
    if (label) {
      label.classList.toggle('mega-menu__link-text', inDrawer);
    }
    document.documentElement.classList.toggle('im8-equalweb-in-drawer', inDrawer);
    document.documentElement.classList.toggle('im8-equalweb-in-discover', inDiscover);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    placeButton();
    bind();

    if (window.matchMedia) {
      var mq = window.matchMedia(MOBILE_MQ);
      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', placeButton);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(placeButton);
      }
    }
    window.addEventListener('resize', placeButton, { passive: true });

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      placeButton();
      bind();
      if ((canOpen() && bound) || tries >= 40) clearInterval(timer);
    }, 250);
  });
})();
